/**
 * Harmonisation visuelle Judge.me — le widget est rendu par judgeme_widgets + judgeme_core.
 */
(function () {
  function textLen(el) {
    return el ? String(el.textContent || '').replace(/\s/g, '').length : 0;
  }

  function hasJudgeMeContent(wrap) {
    if (!wrap) return false;
    return !!wrap.querySelector(
      '.jm-review-widget, .jdgm-write-rev-link, .jdgm-form, .jdgm-rev-widg__reviews .jdgm-rev, .jdgm-rev-widg__header, .jdgm-rev-widg, .jdgm-empty-state .jm-button'
    );
  }

  function hideByExactText(root, texts) {
    if (!root) return;
    root.querySelectorAll('*').forEach(function (el) {
      if (el.children.length > 0) return;
      var t = String(el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t) return;
      texts.forEach(function (needle) {
        if (t !== needle && t.toLowerCase() !== needle.toLowerCase()) return;
        el.setAttribute('data-viva-jdgm-hidden', '1');
      });
    });
  }

  function polishWidget(wrap) {
    if (!wrap || !hasJudgeMeContent(wrap)) return;
    wrap.querySelectorAll('.jm-review-widget-minimal-header__title').forEach(function (el) {
      el.setAttribute('data-viva-jdgm-hidden', '1');
    });
    hideByExactText(wrap, ['Avis Clients', 'Avis clients', 'Aucun élément trouvé', 'Aucun element trouve']);
    var hasReviews = !!wrap.querySelector('.jdgm-rev, .jm-review-item, .jm-align-review-item');
    wrap.classList.toggle('viva-jdgm--no-reviews', !hasReviews);
  }

  function updateWidgetWrap(wrap) {
    var has = hasJudgeMeContent(wrap);
    wrap.classList.toggle('viva-jdgm--has-widget', has);
    wrap.classList.toggle('viva-jdgm--empty', !has);
    if (has) polishWidget(wrap);
  }

  function updatePreviewBadge(wrap) {
    var stars = wrap.querySelector('.jdgm-star');
    var hasOn = wrap.querySelector('.jdgm-star.jdgm--on');
    var text = wrap.querySelector('.jdgm-prev-badge__text');
    var hasText = text && textLen(text) > 2;
    var hideFallback = !!(hasOn || hasText);
    wrap.classList.toggle('viva-jdgm-badge--empty', !hideFallback);
    var fallback = wrap.querySelector('.viva-jdgm-hero-stars');
    if (fallback) {
      fallback.style.display = hideFallback ? 'none' : '';
    }
  }

  function boot() {
    document.querySelectorAll('[data-viva-jdgm-wrap], .viva-jdgm-widget-wrap').forEach(function (wrap) {
      updateWidgetWrap(wrap);
      if (wrap.dataset.vivaJdgmObserved) return;
      wrap.dataset.vivaJdgmObserved = '1';
      new MutationObserver(function () {
        updateWidgetWrap(wrap);
      }).observe(wrap, { childList: true, subtree: true });
    });
    document.querySelectorAll('.viva-jdgm-preview-badge').forEach(updatePreviewBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  [800, 2000].forEach(function (ms) {
    setTimeout(boot, ms);
  });
})();
